<template>
	<div>
		<Header v-if="$store.state.isPC" :sltCity="true"></Header>
    <WapHeader v-if="!$store.state.isPC" :title="'关于我们'" :showhome="false"></WapHeader>
    <div class="box">
    	<h2 v-if="$store.state.isPC">关于我们</h2>
			<div class="aboutwrap" v-if="isZS==0">
				<p class="top">2011年，深圳市觅联网络科技有限公司在深圳成立，进入房地产渠道销售服务领域。</p>
				<p class="title">发展历程</p>
				<p>深圳市觅联网络科技有限公司，旗下拥有B2B渠道分销服务平台和全国首家真正意义上的房地产O2O平台等业务版块。</p>
				<br/>
			</div>
			<div class="aboutwrap" v-if="isZS==1">
				<p class="top">宗萨（全称：深圳市宗萨文化传播有限公司）是面向全国品牌开发商及代理商推出的新房营销代运营服务平台。平台深耕房地产垂直领域，全面布局新房营销线上流量矩阵，旨在搭建开发商、代理商及媒介渠道等多方资源的大数据平台，为开发商、代理商及上下游企业提供综合数字营销解决方案。</p>
				<p class="title">发展历程</p>
				<p>2019 年 “直迈房”成立上线，由深圳市宗萨文化传播有限公司（以下简称：宗萨）独立运营；</p>
				<p>2020 年 深圳市觅房科技有限公司（简称：觅房）对宗萨实施并购，宗萨成为其全资子公司，“直迈房”成为其代运营服务品牌，面向开发商提供销售闭环系统服务及整合营销服务。</p>
				<p class="title">推广产品体系三大创新特点</p>
				<p><b>内容自动化：</b>楼盘信息、房源标签、楼盘动态自动化，图片自动识别，品类聚合页自动优化等等，大大节约建站时长，实现人效翻倍提升；</p>
				<p><b>推广智能化：</b>打通各渠道平台API数据接口，基于“双标签”精准算法匹配，从推广画像、创意生成、投放渠道选择、落地页展现样式等等实现自动化选择；</p>
				<p><b>数据可视化：</b>数据BI系统，立体化、直观展现数据关联，快速完成数据漏斗模型的构建，实现自动数据分析服务。</p>
				<p class="title">其他特色研发成果</p>
				<p><b>双标签数据模型：</b>通过大数据算法，完成用户画像标签与房源产品标签精准匹配。后经数千楼盘、数千万用户累计验证反馈系统数据，帮助用户快速精准实现个性找房需求。同时，营销成本也因此大幅降低。</p>
				<p><b>销售闭环管理系统：</b>打通线上流量监控、电话系统、带看系统、成交系统完整闭环，提升团队整体人效产能，觅房销售团队人均17套/年（传统同行人均3套/年），实现线上投放ROI：7-10。</p>
				<br/>
			</div>

			<div class="aboutwrap" v-if="isZS==2">
				<p class="top">觅天下（全称：深圳市觅天下科技有限公司）是面向全国新房营销商推出的拓客代运营服务平台。平台深耕房地产垂直领域，全面布局新房营销线上流量矩阵，旨在搭建广告主、媒介渠道集成的大数据运营平台，为开发商、代理商及上下游企业提供精细化数字营销解决方案，实现高效精准人房匹配。</p>
				<p class="title">推广产品体系三大创新特点</p>
				<p><b>内容自动化：</b>楼盘信息、房源标签、楼盘动态自动化，图片自动识别，品类聚合页自动优化等等，大大节约建站时长，实现人效翻倍提升；</p>
				<p><b>推广智能化：</b>打通各渠道平台API数据接口，基于“双标签”精准算法匹配，从推广画像、创意生成、投放渠道选择、落地页展现样式等等实现自动化选择；</p>
				<p><b>数据可视化：</b>数据BI系统，立体化、直观展现数据关联，快速完成数据漏斗模型的构建，实现自动数据分析服务。</p>
				<p class="title">其他特色研发成果</p>
				<p><b>双标签数据模型：</b>通过大数据算法，完成用户画像标签与房源产品标签精准匹配。后经数千楼盘、数千万用户累计验证反馈系统数据，帮助用户快速精准实现个性找房需求。同时，营销成本也因此大幅降低。</p>
				<p><b>销售闭环管理系统：</b>打通线上流量监控、电话系统、带看系统、成交系统完整闭环，提升团队整体人效产能，觅房销售团队人均17套/年（传统同行人均3套/年），实现线上投放ROI：7-10。</p>
				<br/>
			</div>


			<div class="aboutwrap" v-if="isZS==3">
				<p class="top">觅达人（全称：深圳市觅达人科技有限公司）是面向全国品牌开发商及代理商推出的新房营销代运营服务平台。平台深耕房地产垂直领域，全面布局新房营销线上流量矩阵，旨在搭建开发商、代理商及媒介渠道等多方资源的大数据平台，为开发商、代理商及上下游企业提供综合数字营销解决方案。</p>
				<p class="title">推广产品体系三大创新特点</p>
				<p><b>内容自动化：</b>楼盘信息、房源标签、楼盘动态自动化，图片自动识别，品类聚合页自动优化等等，大大节约建站时长，实现人效翻倍提升；</p>
				<p><b>推广智能化：</b>打通各渠道平台API数据接口，基于“双标签”精准算法匹配，从推广画像、创意生成、投放渠道选择、落地页展现样式等等实现自动化选择；</p>
				<p><b>数据可视化：</b>数据BI系统，立体化、直观展现数据关联，快速完成数据漏斗模型的构建，实现自动数据分析服务。</p>
				<p class="title">其他特色研发成果</p>
				<p><b>双标签数据模型：</b>通过大数据算法，完成用户画像标签与房源产品标签精准匹配。后经数千楼盘、数千万用户累计验证反馈系统数据，帮助用户快速精准实现个性找房需求。同时，营销成本也因此大幅降低。</p>
				<p><b>销售闭环管理系统：</b>打通线上流量监控、电话系统、带看系统、成交系统完整闭环，提升团队整体人效产能，觅房销售团队人均17套/年（传统同行人均3套/年），实现线上投放ROI：7-10。</p>
				<br/>
			</div>

			<div class="aboutwrap" v-if="isZS==4">
				<p class="top">2011年，杭州溪又网络科技有限公司在重庆成立，进入房地产渠道销售服务领域。</p>
				<p class="title">发展历程</p>
				<p>杭州溪又网络科技有限公司，旗下拥有B2B渠道分销服务平台和全国首家真正意义上的房地产O2O平台等业务版块。</p>
				<br/>
			</div>

			<div class="aboutwrap" v-if="isZS==5">
				<p class="top">优道（全称：深圳市优道匠心教育咨询有限公司南宁第一分公司）是面向全国新房营销商推出的拓客代运营服务平台。平台深耕房地产垂直领域，全面布局新房营销线上流量矩阵，旨在搭建广告主、媒介渠道集成的大数据运营平台，为开发商、代理商及上下游企业提供精细化数字营销解决方案，实现高效精准人房匹配。</p>
				<p class="title">推广产品体系三大创新特点</p>
				<p><b>内容自动化：</b>楼盘信息、房源标签、楼盘动态自动化，图片自动识别，品类聚合页自动优化等等，大大节约建站时长，实现人效翻倍提升；</p>
				<p><b>推广智能化：</b>打通各渠道平台API数据接口，基于“双标签”精准算法匹配，从推广画像、创意生成、投放渠道选择、落地页展现样式等等实现自动化选择；</p>
				<p><b>数据可视化：</b>数据BI系统，立体化、直观展现数据关联，快速完成数据漏斗模型的构建，实现自动数据分析服务。</p>
				<p class="title">其他特色研发成果</p>
				<p><b>双标签数据模型：</b>通过大数据算法，完成用户画像标签与房源产品标签精准匹配。后经数千楼盘、数千万用户累计验证反馈系统数据，帮助用户快速精准实现个性找房需求。同时，营销成本也因此大幅降低。</p>
				<p><b>销售闭环管理系统：</b>打通线上流量监控、电话系统、带看系统、成交系统完整闭环，提升团队整体人效产能，觅房销售团队人均17套/年（传统同行人均3套/年），实现线上投放ROI：7-10。</p>
				<br/>
			</div>

		</div>
		<Footer></Footer>
	</div>
</template>

<script>
import Header from '@/components/public/Header'
import WapHeader from '@/components/public/WapHeader'
import Footer from '@/components/public/Footer'
export default {
	name: 'AboutUs',
	components:{
		'Header': Header,
	    'WapHeader':WapHeader,
	    'Footer': Footer,
	},
	data () {
		return{
			aboutUsList:[],
			// company:'',
			isZS:0
		}
	},
	mounted(){
		this.getAboutUs();
	},
	methods:{
		getAboutUs:function(){
			var url = window.location.href;

			if(url.indexOf('qqbdc')!=-1){
				// this.company = '深圳市美墅信息网络有限公司';
				this.isZS=0;
			}

			if(url.indexOf('metianxia')!=-1 || url.indexOf('zmfang')!=-1){
				// this.company = '深圳市宗萨文化传播有限公司';
				// this.company = '觅达人（深圳市宗萨文化传播有限公司）';
				this.isZS=1;
			}

			if(url.indexOf('mtxfang')!=-1){
				this.isZS=2;
			}

			if(url.indexOf('mdrfang')!=-1){
				this.isZS=3;
			}

			if(url.indexOf('salehg')!=-1){//杭州溪又网络科技有限公司
				this.isZS=4;
			}

			if(url.indexOf('hbaichi')!=-1){//深圳市优道匠心教育咨询有限公司南宁第一分公司
				this.isZS=5;
			}

			// this.$http.get('/api/custome/aboutUs').then((response)=>{
			// 	this.aboutUsList=response.data.result
			// 	console.log(this.aboutUsList);
		    // }).catch((response)=>{
		    //     console.log(response)
		    // })
		},
	},
}
</script>

<style scoped>
	.aboutwrap{padding: 0 15px;}
	.aboutwrap p{padding: 5px 0;font-size: 14px;}
	.aboutwrap .top{padding-top: 60px;}
	.aboutwrap .title{font-size: 16px; font-weight: 700; color: #333; padding-top: 30px;}

	@media (min-width:769px){
		.aboutwrap{padding: 0;line-height:28px;}
		.aboutwrap .top{padding-top: 30px;}
		h2{text-align:center;font-size:36px;line-height:50px;margin-top:50px;}
	}
</style>



// WEBPACK FOOTER //
// src/components/AboutUs.vue